import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { z } from 'zod';
import { formatDate, startOfYear } from '~/utils/date';

export const querySchema = z
  .object({
    person: z.string().optional(),
    competition_type: z.enum(['classic', 'equipped', 'ifn', 'para']).default('classic'),
    age_category_id: z
      .string()
      .transform(v => (v ? Number(v) : undefined))
      .optional(),
    weight_class_id: z
      .string()
      .transform(v => (v ? Number(v) : undefined))
      .optional(),
    from_date: z.string().optional().default(formatDate(startOfYear(), 'yyyy-mm-dd')),
    to_date: z.string().optional(),
    sex: z.enum(['F', 'M', 'ALL']).default('ALL'),
  })
  .merge(paginationSchema);

export type QuerySchema = z.infer<typeof querySchema>;
